import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getApartments = state => state.dobovoApartments

export const selectApartmentsFetching = state => path(['dobovoApartments', 'isFetching'], state)

export const selectApartments = createSelector(getApartments, apartments => {
    if (!(isEmpty(apartments.entities) || isEmpty(apartments.result))) {
        const items = apartments.entities.apartments
        return apartments.result.map(id => items[id])
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/dobovoSelectors/dobovoApartments.js